import {
    faCalendarCircleUser,
    faGear,
    faHouseWindow,
    faPersonCircleCheck,
    faReceipt,
} from "@fortawesome/pro-solid-svg-icons"
import {
    SERVICE_CENTER_ADMIN_ROUTE,
    SERVICE_CENTER_REPORTS_GUESTS_ROUTE,
    SERVICE_CENTER_REPORTS_MEETING_ROOMS_ROUTE,
    SERVICE_CENTER_REPORTS_MEETING_SERVICE_ROUTE,
    SERVICE_CENTER_REPORTS_ROUTE,
} from "../../../constants/routes"
import { NarrowNavItem } from "../../../shared/layouts/NarrowNavItems"
import { EnvironmentType } from "../../environment/envTypes"

// `environments` lists the envs where a nav item is SHOWN; omit it to show everywhere.
const defaultEnvs = [EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo, EnvironmentType.QA]

export const serviceCenterReportingNavItems: NarrowNavItem[] = [
    {
        icon: faHouseWindow,
        label: "User",
        translationLabel: "service-center-nav-item-user-label",
        shortLabelKey: "service-center-nav-bottom-bar-home-label",
        route: SERVICE_CENTER_REPORTS_ROUTE,
    },
    {
        icon: faReceipt,
        label: "Canteen",
        translationLabel: "service-center-nav-item-canteen-label",
        shortLabelKey: "service-center-nav-bottom-bar-canteen-label",
        route: SERVICE_CENTER_REPORTS_MEETING_SERVICE_ROUTE,
        environments: [EnvironmentType.Local, EnvironmentType.Test],
    },
    {
        icon: faCalendarCircleUser,
        label: "Meeting rooms",
        translationLabel: "service-center-nav-item-meeting-rooms-label",
        shortLabelKey: "service-center-nav-bottom-bar-meeting-rooms-label",
        route: SERVICE_CENTER_REPORTS_MEETING_ROOMS_ROUTE,
        environments: [...defaultEnvs, EnvironmentType.Prod],
    },
    {
        icon: faPersonCircleCheck,
        label: "Guests",
        translationLabel: "service-center-nav-item-guests-label",
        shortLabelKey: "service-center-nav-bottom-bar-guests-label",
        route: SERVICE_CENTER_REPORTS_GUESTS_ROUTE,
        environments: [...defaultEnvs, EnvironmentType.Prod],
    },
    {
        icon: faGear,
        label: "Settings",
        translationLabel: "service-center-nav-item-settings-label",
        shortLabelKey: "service-center-nav-bottom-bar-settings-label",
        route: SERVICE_CENTER_ADMIN_ROUTE,
        environments: [...defaultEnvs, EnvironmentType.Prod],
    },
]
